module.exports= {
    "postbox-text": "Skriv din kommentar her (mindst 3 tegn)",
    "postbox-author": "Navn (valgfrit)",
    "postbox-email": "E-mail (valgfrit)",
    "postbox-website": "Hjemmeside (valgfrit)",
    "postbox-preview": "Forhåndsvisning",
    "postbox-edit": "Rediger",
    "postbox-submit": "Send",

    "num-comments": "En Kommentar\n{{ n }} Kommentarer",
    "no-comments": "Ingen kommentarer endnu",

    "comment-reply": "Svar",
    "comment-edit": "Rediger",
    "comment-save": "Gem",
    "comment-delete": "Fjern",
    "comment-confirm": "Bekræft",
    "comment-close": "Luk",
    "comment-cancel": "Annuller",
    "comment-deleted": "Kommentar slettet.",
    "comment-queued": "Kommentar i kø for moderation.",
    "comment-anonymous": "Anonym",
    "comment-hidden": "{{ n }} Skjult",

    "date-now": "lige nu",
    "date-minute": "et minut siden\n{{ n }} minutter siden",
    "date-hour": "en time siden\n{{ n }} timer siden",
    "date-day": "Igår\n{{ n }} dage siden",
    "date-week": "sidste uge\n{{ n }} uger siden",
    "date-month": "sidste måned\n{{ n }} måneder siden",
    "date-year": "sidste år\n{{ n }} år siden"
};
